"use client";

import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

interface KpiCardProps {
  title: string;
  value: string;
  subtitle?: string;
  icon: LucideIcon;
  trend?: { value: string; positive: boolean };
}

const KpiCard = ({ title, value, subtitle, icon: Icon, trend }: KpiCardProps) => (
  <div className="rounded-lg border border-border/50 bg-card p-5 shadow-sm">
    <div className="flex items-start justify-between">
      <div>
        <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">{String(title)}</p>
        <p className="mt-2 text-2xl font-semibold text-foreground">{String(value)}</p>
        {subtitle != null && subtitle !== "" && <p className="mt-0.5 text-xs text-muted-foreground">{String(subtitle)}</p>}
        {trend && (
          <p className={cn("mt-1 text-xs font-medium", trend.positive ? "text-accent" : "text-destructive")}>
            {String(trend.value)}
          </p>
        )}
      </div>
      <div className="p-2 rounded-md bg-secondary">
        <Icon className="h-4 w-4 text-muted-foreground" />
      </div>
    </div>
  </div>
);

export default KpiCard;
